import React, { Component } from "react";
import { connect } from "react-redux";
import mapDispatch from "~/misc/mapDispatch";
import Results from "~/components/search/results/results";
import {push as changeURL} from 'react-router-redux';
import {
  loadsMore,
  loadsSortDirectly ,
  lodasHideBroker,
  loadsCollectionTheCompany,
  loadsNoCollectionCompsny,
  loadsSearchDriectly
} from "~/modules/loadsSearch/actions";

import {
  loadCheck,
  loadCheckedAll,
  showMore
} from '~/modules/cityRatioList/actions'
import { getLoads } from '~/modules/cityRatioList/actions';
import css from "./index.css"
import { getUrlQeury } from "~/misc/formatUrlquery";
import * as urls from "~/routing/urls"
import { ModeType } from "../../modelData";
import Spinner from "~/components/common/Spinner";
import SearchLoad from "../RatioTable/searchLoad";
import SortSelect from "../RatioTable/SortSelect";
import { idToHumanLowerCase } from "~/misc/equipment";
import { removeQuery } from "~/misc/getQuery";
import deeplink from "~/misc/deeplink";
const openDeeplink = () => {
  const [isMobile] = removeQuery(['isMobile']);
  if(isMobile) {
    setTimeout(()=> {
      window.location.href = deeplink.openCapacityRatio({hash: isMobile});
    }, 0)
  }
} 
class RatioMapList extends Component {
  constructor(props) {
    super(props);
    this.showMore = this.showMore.bind(this);
    this.renderList = this.renderList.bind(this);
    const query = getUrlQeury();
    const { location} = query;
    const equipmentArray =  query.equipment ? query.equipment.split(",") : null
    this.state = {
      loading: true,
      location,
      loadsSortBy: 'Age',
      loadsSortOrder: 'asc',
      equipmentArray,
    }
  }
  componentDidMount(){
    this.searchLoads();
    openDeeplink();
  }
  loadsSort = ({sort_by,sort_order}) => {
    this.setState({
      loadsSortBy: sort_by,
      loadsSortOrder: sort_order.toUpperCase(),
    }, this.searchLoads)
  }
  searchLoads() {
    const {search} = this.props;
    const {loadsSortBy, loadsSortOrder, location, equipmentArray} = this.state;
    this.setState({
      loading: true
    })
    search({
      equipment: equipmentArray ? idToHumanLowerCase[equipmentArray[0]] : "",
      pickUp: location,
      offset: 0,
      limit: 200,
      sort: loadsSortBy,
      sortOrder: loadsSortOrder
    }).then(res=> {
      this.setState({
        loading: false
      })
    })
  }

  showMore(limit) {
    const mainData = this.props.loadsSearch;
    const newLimit = {
      limit: parseFloat(mainData.query.limit) + parseFloat(limit),
    };

    // FIXME: update location for keeping current state in query-string
    return this.props.loadsMore(limit);
  }
  renderList  () {
    const {location, loadsSortBy, loadsSortOrder } = this.state;
    const mainData = this.props.cityRatioList;
    return (<div>
      <div className={css.listHeader}>
          <div className={css.listHeaderLocation}>
            {location} → Anywhere
          </div>
          <div className={css.listHeaderMatchCourt}>
            <span className={css.listHeaderMatchCourtNumber}>{mainData.originalList.length}</span> excat matches
          </div>
          <div className={css.listHeaderEmpty}></div>
          <div className={css.listHeaderBack} onClick={this.props.goBack}>
            <div className={css.listHeaderBackIcon}>
            </div>
            Back to Map
          </div>
        </div>
        <div className={css.RatioSort}>
          <SearchLoad isSimilar={false} />
          <SortSelect query={{
            sort_by : loadsSortBy,
            sort_order: loadsSortOrder.toLowerCase()
          }}  loadsSort={this.loadsSort} isSimilar={false} fetching={mainData.status === 'sorting'} />
        </div>
        <Results
          isSimilar={false}
          isMain={true}
          query={mainData.query}
          hasItems={mainData.hasItems}
          total={mainData.total}
          results={mainData.results}
          status={mainData.status}
          sorting={false}
          localSum={mainData.originalList}
          headerSticky={false}
          checkedAll={mainData.checkedAll}
          checkClick={this.props.loadCheck}
          checkedAllClick={this.props.loadCheckedAll}
          showMore={this.showMore}
          identity={mainData.identity}
          checkbox={true}
          hideBroker={this.props.lodasHideBroker}
          collectionTheCompany={this.props.loadsCollectionTheCompany}
          noCollectionCompany={this.props.loadsNoCollectionCompsny}
          saveClick={true}
          hideClick={true}
        />
    </div>)
  }


  render() {
    const { loading } = this.state;
    return (
      <div className={css.pageWarp}>
        <div className={css.title}>Capacity Ratio</div>
        {loading ? <Spinner></Spinner> :this.renderList()}
      </div>
    );
  }
}

export default connect(
  ({ loadsSearch, cityRatioList, similarLoads, user, account, premiumSwitch }) => ({
    loadsSearch,
    cityRatioList,
    similarLoads,
    account: account,
    isLoggedIn: user.isLoggedIn,
    isL2User: user.isL2User,
    memberSwitchData: premiumSwitch.memberSwitchData,
    localLoadsClickTimes: premiumSwitch.localLoadsClickTimes,
  }),
  mapDispatch({
    search: (props, query)=> getLoads(query),
    similarLoadsSort: (props, data) => similarLoadsSort(data),
    loadsMore: (props, data) => showMore(data),
    similarHideBroker: (props, data) => similarHideBroker(data),
    lodasHideBroker: (props, data) => lodasHideBroker(data),
    similarCollectionTheCompany: (props, data) => similarCollectionTheCompany(data),
    similarNoCollectionCompsny: (props, data) => similarNoCollectionCompsny(data),
    loadsCollectionTheCompany: (props, data) => loadsCollectionTheCompany(data),
    loadsNoCollectionCompsny: (props, data) => loadsNoCollectionCompsny(data),
    loadCheck: (props, id) => loadCheck(id),
    loadCheckedAll: () => loadCheckedAll(),
    similarLoadCheck: (props, id) => similarLoadCheck(id),
    similarLoadCheckedAll: () => similarLoadCheckedAll(),
    loadsRefresh: (props, data) => loadsSearch(form2query(data)),
    updateGeoFromStateName: (props, data) => updateFromStateName('search:origin-field', data),
    showUpgradeToStandard: props =>
      modalChange('pop', {
        source: 'load-list',
        type: 'pop_upgrade_to_loads_above_limits',
      }),
    showUpgradeToPremium: (props, data) =>
      modalChange('pop', {
        times: data,
        source: 'load-list',
        type: 'pop_upgrade_to_new_standard',
      }),
    searchLoads: () => modalChange(modes.LOAD_DISAPPER, { type: 'pop' }),
    gotoHp: (props, source) => changeURL(`/hp?${source}`), 
    goBack: (props, source) => window.open(`${urls.CAPACITYRATIO}?to=${ModeType.MAP}`,'_self'),
  })
)(RatioMapList);



// WEBPACK FOOTER //
// ./src/pages/CapacityRatio/compontents/RatioMapList/index.js